import citiesByUrl from '@app/data/cities-mapped-by-url.json';
import citiesFranchised from '@app/data/franchised-cities.json';
import { City } from '@app/types';

type CitiesMappedByUrl = {
  [key: string]: City;
};

export function getCityByUrl(cityUrl: string): City | null {
  return (citiesByUrl as CitiesMappedByUrl)[cityUrl] ?? null;
}

export function isFranquisedCity(cityUrl: string) {
  return citiesFranchised.some((cf) => cf.city === cityUrl);
}
